import type { CustomerOrderDetail } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { canChangeDestinationAddress } from '@/entities/order';
import { shippingFeeOf } from '@/entities/quote';
import { OrderDestinationCard } from './order-destination-card';

interface OrderDestinationsProps {
  readonly order: CustomerOrderDetail;
  readonly pending: boolean;
  /** 그 배송지의 [배송지 변경] — 상세 위젯이 그 배송지 주소 변경 대화상자를 연다. */
  readonly onChangeAddress: (destinationId: string) => void;
}

/**
 * 배송지 목록(SUPER-86 spec §5-4·§5-5) — 주문 배송지(sortOrder 순)마다 카드 하나. 배송비는 발행본의 그 배송지 배송비 줄
 * (견적 배송지 id 로 짝)에서 읽는다.
 */
export const OrderDestinations = ({
  order,
  pending,
  onChangeAddress,
}: OrderDestinationsProps): ReactElement => {
  const awaitingShipment = order.status === 'PAID' && order.fulfillmentStatus !== 'DELIVERED';
  return (
    <section aria-label="배송지" className="flex flex-col gap-5">
      <div className="flex flex-col gap-3">
        <p
          aria-hidden
          className="text-[11px] leading-none font-semibold tracking-[0.18em] text-muted-foreground uppercase"
        >
          Shipping
        </p>
        <h2 className="text-base font-semibold">배송지 {order.destinations.length}곳</h2>
      </div>
      {order.destinations.map((destination, index) => (
        <OrderDestinationCard
          key={destination.id}
          order={index + 1}
          destination={destination}
          fee={shippingFeeOf(order.quoteVersion.lines, destination.quoteDestinationId)}
          awaitingShipment={awaitingShipment}
          editable={canChangeDestinationAddress(order, destination)}
          pending={pending}
          onChangeAddress={() => onChangeAddress(destination.id)}
        />
      ))}
    </section>
  );
};
